import { apiClient } from '../../plugins/api'
import {
    CHANGE_LOST_PASSWORD_REQUEST,
    CHANGE_PASSWORD_REQUEST,
    CHECK_EMAIL_REQUEST,
    CHECK_NICKNAME_REQUEST,
    INFO_REQUEST,
    INFO_SUCCESS,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOST_PASSWORD_REQUEST,
    REGISTER_REQUEST,
    SET_USER_TEAM,
    VERIFY_LOST_PASSWORD_REQUEST,
    RESEND_ACTIVATION_EMAIL_REQUEST,
    ACTIVATE_EMAIL_REQUEST,
    ACTIVATE_EMAIL_SUCCESS,
    GET_USER_DETAIL_REQUEST,
    LISTING_USERS_REQUEST,
    UPDATE_PROFILE_REQUEST,
} from '../actions/user'
import { FORGOT_TEAM } from '../actions/team'

const state = {
    user: null,
};

const getters = {
    isLoggedIn (state) {
        return state.user !== null && state.user !== undefined && state.user.id;
    },
};

const actions = {
    async [REGISTER_REQUEST] ({ commit }, user) {
        const { data } = await apiClient().post('/user/registration', user);
        localStorage.setItem('auth-token', data.token);
        commit(LOGIN_SUCCESS, data);
    },
    async [LOGIN_REQUEST] ({ commit }, credentials) {
        const { data } = await apiClient().post('/user/login', credentials);
        localStorage.setItem('auth-token', data.token);
        commit(LOGIN_SUCCESS, data);
    },
    async [LOGOUT_REQUEST] ({ commit }) {
        await apiClient().post('/user/logout');
        localStorage.removeItem('auth-token');
        commit(LOGOUT_SUCCESS);
        commit('team/' + FORGOT_TEAM, {}, { root: true });
    },
    async [INFO_REQUEST] ({ commit }) {
        if (!localStorage.getItem('auth-token')) {
            return;
        }

        const { data } = await apiClient().get('/user/info');
        commit(INFO_SUCCESS, data);
    },
    async [CHANGE_PASSWORD_REQUEST] ({ commit }, { oldPassword, newPassword }) {
        await apiClient().post('/user/change-password', { oldPassword, newPassword });
    },
    async [CHECK_NICKNAME_REQUEST] ({ commit }, { nickname }) {
        const { data } = await apiClient().get('/user/check-nickname?nickname=' + nickname);
        return data.isAvailable;
    },
    async [CHECK_EMAIL_REQUEST] ({ commit }, { email }) {
        const { data } = await apiClient().get('/user/check-email?email=' + email);
        return data.isAvailable;
    },
    async [LOST_PASSWORD_REQUEST] ({ commit }, { email }) {
        await apiClient().post('/user/lost-password', { email });
    },
    async [VERIFY_LOST_PASSWORD_REQUEST] ({ commit }, { token }) {
        await apiClient().post('/user/verify-lost-password-token', { token });
    },
    async [CHANGE_LOST_PASSWORD_REQUEST] ({ commit }, { token, newPassword }) {
        await apiClient().post('/user/new-password', { token, newPassword });
    },
    async [RESEND_ACTIVATION_EMAIL_REQUEST] () {
        await apiClient().post('/user/resend-activation-email');
    },
    async [ACTIVATE_EMAIL_REQUEST] ({ commit }, { token }) {
        await apiClient().post('/user/activate-email', { token });
        commit(ACTIVATE_EMAIL_SUCCESS);
    },
    async [GET_USER_DETAIL_REQUEST] ({ commit }, { id }) {
        const { data } = await apiClient().get('/user/detail?id=' + id);
        return data;
    },
    async [LISTING_USERS_REQUEST] ({ commit }, filter = null) {
        let params = null;
        if (filter !== null) {
            params = new URLSearchParams();
            if (filter.nickname) {
                params.append('nickname', filter.nickname);
            }
            if (filter.team) {
                params.append('team', filter.team);
            }
        }
        let url = '/user/find';
        if (params !== null) {
            url += '?' + params.toString();
        }
        const { data } = await apiClient().get(url);
        return data.users;
    },
    async [UPDATE_PROFILE_REQUEST] ({ dispatch }, { cityId, avatar }) {
        await apiClient().post('/user/update-profile', { cityId, avatar });
        dispatch(INFO_REQUEST);
    },
};

const mutations = {
    [LOGIN_SUCCESS] (state, { user }) {
        state.user = user;
    },
    [LOGOUT_SUCCESS] (state) {
        state.user = null;
    },
    [INFO_SUCCESS] (state, { user }) {
        state.user = user;
    },
    [ACTIVATE_EMAIL_SUCCESS] (state) {
        if (state.user) {
            state.user.activated = true;
        }
    },
    [SET_USER_TEAM] (state, payload) {
        state.user.teamId = payload.teamId || null;
        state.user.teamName = payload.teamName || '';
        state.user.teamBlazon = payload.teamBlazon || null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
